module.exports = __webpack_public_path__ + "img/21.cd4c304c.jpg";